<template>

    <div class="alert-card mdl-card">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">{{ title | label }}</h2>
      </div>
      <div class="mdl-card__supporting-text">
        {{{ message | label }}}
      </div>
      <div class="mdl-card__actions mdl-card--border">
        <a v-if="goto" class="mdl-button mdl-button--colored mdl-js-button"
            v-link="goto">
          {{ 'alert.label.ok' | label }}
        </a>
        <a v-else class="mdl-button mdl-button--colored mdl-js-button"
            v-on:click="$dispatch('alert-done')">
          {{ 'alert.label.ok' | label }}
        </a>
      </div>
    </div>

</template>

<script>
module.exports = {
  props: [ 'title', 'message', 'goto' ]
}
</script>

<style scoped>
  .alert-card {
    width: 100%;
    margin-top: 8px;
  }
  .mdl-card__actions {
    /* position: absolute; */
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// Alert.vue?1747b998